import { type CellContext } from '@tanstack/react-table';

interface CellTitleSubtitleProps<TData, TValue> extends CellContext<TData, TValue> {
    title: React.ReactNode;
    subtitle: React.ReactNode;
}
export function CellTitleSubtitle<TData, TValue>({ title, subtitle }: CellTitleSubtitleProps<TData, TValue>) {
    return (
        <div className="flex flex-col gap-0">
            <span>{title}</span>
            <span className="-mt-px whitespace-nowrap text-gray-500">{subtitle}</span>
        </div>
    );
}
